module.exports = __webpack_public_path__ + "img/selecione-macroprocesso.0181060d.svg";